import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    fetchEntity: ['uuid', 'query'],
    fetchEntitySuccess: ['entity'],
    fetchEntityFailure: ['error'],

    updateEntity: ['uuid', 'entity', 'query'],
    updateEntitySuccess: ['entity'],
    updateEntityFailure: ['error'],
});


export const EntityTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    loading: false,
    error: null,
    entity: null,
    lastSyncDt: null,
})

const resetState = () => INITIAL_STATE;

export const reducer = createReducer(INITIAL_STATE, {
    // Fetch a single work order
    [Types.FETCH_ENTITY]: (state) => {
        return {
            ...state,
            loading: true,
            error: null,
            entity: null,
        };
    },

    [Types.FETCH_ENTITY_SUCCESS]: (state, {entity}) => {
        return {
            ...state,
            loading: false,
            error: null,
            entity,
        };
    },

    [Types.FETCH_ENTITY_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
            entity: null,
        };
    },

    // Update an work order
    [Types.UPDATE_ENTITY]: (state, action) => {
        return {
            ...state,
            loading: true,
            error: null,
        };
    },

    [Types.UPDATE_ENTITY_SUCCESS]: (state, {entity}) => {
        return {
            ...state,
            loading: false,
            entity,
            error: null,
            lastSyncDt: new Date().getTime(),
        };
    },

    [Types.UPDATE_ENTITY_FAILURE]: (state, {error}) => {
        return {
            ...state,
            loading: false,
            error,
        };
    },
});



// WEBPACK FOOTER //
// ./src/Redux/EntityRedux.js